import { Hdc1Dot5MembershipDetailsResponse } from "../../../types/responses";

import { hdcInfo } from "./createInsuranceBill";

type FetchHdc1Dot5MembershipDetailsData = Partial<
  Hdc1Dot5MembershipDetailsResponse["data"]
>;

export const getHdc1Dot5MembershipDetails = (
  defaultDetails: FetchHdc1Dot5MembershipDetailsData
): Hdc1Dot5MembershipDetailsResponse => {
  const level = defaultDetails?.level || 1;
  const price = hdcInfo[level - 1].cost;

  return {
    data: {
      effectiveAt: "1999-01-01",
      expireAt: "2070-12-31",
      price,
      level,
      ...defaultDetails,
    },
  };
};
